import type { InputHTMLAttributes, SelectHTMLAttributes, ReactNode } from 'react';
import './components.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
  startIcon?: ReactNode;
}

export function Input({
  label,
  hint,
  error,
  startIcon,
  className = '',
  ...rest
}: InputProps) {
  return (
    <label className={`iris-input ${className}`}>
      {label && <span className="iris-input-label">{label}</span>}
      <span className={`iris-input-shell ${error ? 'has-error' : ''}`}>
        {startIcon && <span className="iris-input-icon">{startIcon}</span>}
        <input {...rest} />
      </span>
      {error ? (
        <span className="iris-input-error">{error}</span>
      ) : hint ? (
        <span className="iris-input-hint">{hint}</span>
      ) : null}
    </label>
  );
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: { value: string; label: string }[];
}

export function Select({ label, options, className = '', ...rest }: SelectProps) {
  return (
    <label className={`iris-input ${className}`}>
      {label && <span className="iris-input-label">{label}</span>}
      <span className="iris-input-shell">
        <select {...rest}>
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </span>
    </label>
  );
}
